import React, {PropTypes} from 'react';

const TextInput = ({name, inputType, label, labelClass, inputClass, wrapperClass, onChange, disabled,
    placeholder, helpText, value, error, diffObject}) => {
  wrapperClass += ' form-group';
  if (diffObject && !!diffObject[name]) {
    wrapperClass += ' has-warning';
    wrapperClass += ' has-feedback';
  }
  inputClass += ' form-control';
  labelClass += ' control-label';
  if(error && error.lendth > 0) {
    wrapperClass += ' ' + 'has-error';
  }
  let inputValue = value ? value : '';
  return (
    <div className={wrapperClass}>
      <label htmlFor={name} className={labelClass}>
        {label}
      </label>
      <input type={inputType || 'text'}
        name={name}
        disabled={disabled}
        className={inputClass}
        placeholder={placeholder}
        onChange={onChange}
        value={inputValue}
         />
      {helpText && <p className="help-block">{helpText}</p>}
      {error && error.map((item, index) =>{
        return(<div key={index} className="alert alert-danger alert-sm input-error">{item}</div>);
      })}
      {diffObject && diffObject[name] && <span className="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" />}
      {diffObject && diffObject[name] && <p className="help-block">
          {'Siste godkjente verdi: '}
          <strong>
            {diffObject[name][0]}
          </strong>
      </p>}
    </div>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
TextInput.propTypes = {
  name: PropTypes.string,
  inputType: PropTypes.string,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  helpText: PropTypes.string,
  inputClass: PropTypes.string,
  wrapperClass: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  error: PropTypes.array,
  disabled: PropTypes.bool,
  diffObject: PropTypes.object,
};

export default TextInput;



/** WEBPACK FOOTER **
 ** ./src/components/common/TextInput.js
 **/